import { render, staticRenderFns } from "./UserSites.vue?vue&type=template&id=21528d70&scoped=true"
import script from "./UserSites.vue?vue&type=script&lang=js"
export * from "./UserSites.vue?vue&type=script&lang=js"
import style0 from "./UserSites.vue?vue&type=style&index=0&id=21528d70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21528d70",
  null
  
)

export default component.exports